/* ==========================================================================
   PLP Image Links - Smooth Scrolling Functionality
   ========================================================================== */

/**
 * Smooth scrolling functionality for anchor links
 * Handles internal page navigation with smooth scrolling animation
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.group-img-links__item').forEach(item => {
    item.addEventListener('click', (e) => {
      if (e.currentTarget.hash && e.currentTarget.hash.length !== 0) {
        e.preventDefault();
        
        const hash = e.currentTarget.hash;
        const targetElement = document.querySelector(hash);
        
        if (!targetElement) {
          // Fallback to default behavior if target not found
          window.location.href = e.currentTarget.hash;
          return;
        }
        const scrollPosition = targetElement.offsetTop;
        // Update browser history
        window.history.pushState(null, null, hash);
        
        // Smooth scroll to target
        window.scrollTo({
          top: scrollPosition - 100,
          behavior: 'smooth'
        });
      }
    });
  });
});
